// Keep unexpected Shopify errors intact; soften only known stock limit messages.
window.ansoStockMessage = (message) => {
  if (typeof message !== 'string') return message;
  const limited = message.match(/(?:Tylko|Only)\s+(\d+)\s+(?:poz\.|szt\.?|items?)/i);
  if (limited && /(?:dodano do koszyka|added to your cart)/i.test(message)) {
    if (document.documentElement.lang.startsWith('en')) return `Availability is limited — ${limited[1]} item(s) were added to your cart. Please check the quantity before ordering.`;
    return `Dostępność jest ograniczona — do koszyka dodano ${limited[1]} szt. Sprawdź ilość w koszyku przed zamówieniem.`;
  }
  return message;
};
